var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendO(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send-o",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.803,
    height: 40.823,
    viewBox: "0 0 40.803 40.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M40.141,3.681a1.423,1.423,0,0,1,.615,1.457L34.927,40.109a1.435,1.435,0,0,1-.729,1.025,1.4,1.4,0,0,1-.706.182,1.532,1.532,0,0,1-.546-.114l-12-4.9-6.785,7.445a1.342,1.342,0,0,1-1.07.478,1.3,1.3,0,0,1-.524-.091,1.367,1.367,0,0,1-.683-.535,1.466,1.466,0,0,1-.25-.831V32.482L.89,28.088a1.337,1.337,0,0,1-.911-1.252,1.328,1.328,0,0,1,.729-1.343L38.593,3.636A1.322,1.322,0,0,1,40.141,3.681ZM32.355,37.81,37.386,7.688,4.738,26.517l7.65,3.119L32.036,15.088,21.153,33.233Z",
    transform: "translate(0.026 -3.407)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendO);
export default __webpack_public_path__ + "static/media/send-o.b6eafecd13073d1cf69f716d42305893.svg";
export { ForwardRef as ReactComponent };